import Vue from 'vue'
import {adminRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import { globalObject } from '@/utils/proxyDataUtil'

import FacilityControl from '@/componentsReusable/FacilityControl.vue'
import StateControl from '@/componentsReusable/StateControl.vue'
import CustomDropdownControl from '@/componentsReusable/CustomDropdownControl.vue'
import ButtomToggleControl from '@/componentsReusable/ButtonToggleControl.vue'
import flatPickr from 'vue-flatpickr-component';
import MaskedInput from 'vue-text-mask';
import { ViewStateType } from '@/enums/ViewStateType';
import ProviderAdvancedSearchFields from "@/components/providers/ProviderAdvancedSearchFields";
import {createAdvancedSearchFilters} from "@/components/providers/models/ProviderAdvancedSearchModel";

export default Vue.extend({
  name: 'ProvidersAdvancedSearch',
  data () {
    return {
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      processing: false,
      loadingSearchResults: false,

      searchCountResults: 0,
      allowForceResultsMaximum: 400,
      allowForceResults: false,
      searchResults: [],

      searchParametersCardExpanded: true,
      pullingReportData: false,
      advancedSearchFilters: createAdvancedSearchFilters()
    };
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    FacilityControl,
    StateControl,
    CustomDropdownControl,
    flatPickr,
    ButtomToggleControl,
    MaskedInput,
    ProviderAdvancedSearchFields
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  mounted: function () {
    if (this.$store.state.viewState[ViewStateType.PROVIDER_SEARCH_ADVANCED]){
      const storedSearchFilters = this.$store.state.viewState[ViewStateType.PROVIDER_SEARCH_ADVANCED];
      // this allows for new filter types to be added without breaking everything
      this.advancedSearchFilters = Object.assign(this.advancedSearchFilters, storedSearchFilters);

      this.searchProviders();
    }
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    title (title: string ) {
      if (title && title.length) {
        return ' | ' + title;
      }
      return '';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    state (state: any) {
      return state.stateFull + ", " + state.stateAbbrev;
    },
    stateWithComma (state: any) {
      return state ? ", " + state : '';
    }
  },
  methods: {
    clearAll () {
      this.advancedSearchFilters = createAdvancedSearchFilters();
      this.$store.dispatch('viewState/updateViewState', {name: ViewStateType.PROVIDER_SEARCH_ADVANCED, value: null});
    },
    searchProviders (force: boolean = false) {
      let self = this;
      let forceResults = force;
      if (this.processing) { return; }
      this.processing = true;
      self.loadingSearchResults = true;
      self.$store.dispatch('viewState/updateViewState', {name: ViewStateType.PROVIDER_SEARCH_ADVANCED, value: JSON.parse(JSON.stringify(this.advancedSearchFilters))});
      HTTP.post('/api/providers/advanced-search?forceResults=' + forceResults, { advancedSearchFilters: this.advancedSearchFilters} )
      .then(function (response) {
        self.processing = false;
        // If the response is a count, display the count message
        // If the response is a list, display the list

        // If the search results results are empty, display the count
        // If the count is greater than 0 display the count at the option to force retriving the results
        //  as long as the results are less than allowForceResultsMaximum

        let queryCountResults = response.data.data.count;

        self.searchCountResults = queryCountResults;
        self.searchResults = response.data.data.results;
        self.allowForceResults = queryCountResults < self.allowForceResultsMaximum;

        self.loadingSearchResults = false;
      })
      .catch(function () {
        self.loadingSearchResults = false;

        self.processing = false;
        // if there was an error, "notify" the error
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Getting Results',
          text: 'Something went wrong getting search results!',
        });
      })
    },

    selectProvider (provider: any) {
      // We are using this "globalObject" as a temporary holder of the provider
      // object so we can display the provider's name right away on the next page
      // to avoid the network delay making us show a blank name for a view milliseconds.
      globalObject.variable1 = provider;
      this.$router.push({name: 'Provider', params: {providerId: provider.id}});
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
      });
    },
    goToSimpleSearch () {
      this.$router.push({name: 'Providers'});
    },

  }
})



// WEBPACK FOOTER //
// ./src/components/providers/ProvidersAdvancedSearch.ts